import { render, staticRenderFns } from "./MenuSidebar.vue?vue&type=template&id=aa2c22b8&scoped=true"
import script from "./MenuSidebar.vue?vue&type=script&lang=js"
export * from "./MenuSidebar.vue?vue&type=script&lang=js"
import style0 from "./MenuSidebar.vue?vue&type=style&index=0&id=aa2c22b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2c22b8",
  null
  
)

export default component.exports